import React from "react";

export default function EditIcon(props) {
  return (
    <svg width={20} height={20} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.3074 2.70099L17.2574 4.62223C17.5824 4.94244 17.5824 5.4597 17.2574 5.7799L15.7324 7.28241L12.6074 4.2035L14.1324 2.70099C14.2907 2.54499 14.499 2.46289 14.7157 2.46289C14.9324 2.46289 15.1407 2.53678 15.3074 2.70099ZM2.49902 14.1627V17.2417H5.62402L14.8407 8.16092L11.7157 5.08202L2.49902 14.1627ZM4.93236 15.5996H4.16569V14.8442L11.7157 7.40557L12.4824 8.16093L4.93236 15.5996Z"
        fill="#2B56A3"
      />
    </svg>
  );
}
